import React from 'react';
import styled from 'styled-components';
import { Text } from '@catalogo/theme-text';

export const PickupMessage = ({ options }) => {
  if (options.length === 1 && ['LASA', 'LASAPRIME'].includes(options[0].id)) {
    return (
      <Message size="sm" spacingTop="xs">
        Quando o produto for entregue na loja, avisaremos por e-mail pra você ir lá retirar, tá bem?
      </Message>
    );
  }

  return null;
};

const Message = styled(Text)`
  font-size: 12px;
  margin-top: 10px;
  display: block;
`;
